import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";

export function locationsErrorMessageForDistributionWarehouseBrand(
  locationType: LocationType,
  distributionWarehouseBrand: string | null | undefined,
) {
  if (locationType === LocationType.DistributionWarehouse) {
    if (distributionWarehouseBrand === undefined) {
      return "Required";
    }
  }
  return undefined;
}
